import styled from 'styled-components';

import * as variables from '../../../common/styles/variables';
import * as colors from '../../../common/styles/colors';
import * as mixins from '../../../common/styles/mixins';
import { respondTo } from '../../../common/styles/mixins';

export const BlockWrapper = styled.div`
  ${mixins.boxShadowPrimary};
  background-color: ${({ theme }) => theme.bg.secondary};
  border-radius: ${variables.globalRadius};
  padding: ${variables.spacingSmall};
  margin-bottom: ${variables.spacingMedium};

  ${respondTo.desktop`
    padding: ${variables.spacingMedium};
  `};

  h4 {
    font-size: ${variables.fontSizeLargeX};
    margin: 0 0 ${variables.spacingSmall};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.primary.bg};
  }

  .highlight {
    color: ${({ theme }) => theme.primary.bg};
  }

  .opposite-align {
    ${respondTo.desktop`
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    `};
  }

  .info-text {
    margin: 0 0 ${variables.spacingSmall};

    ${respondTo.desktop`
      width: 45%;
      margin: 0;
    `};
  }

  .submit-btn {
    display: inline-block;
    margin: 0;

    ${respondTo.desktop`
      min-width: 250px;
    `};
  }

  .multisiteModeLayout {
    padding-top: ${variables.spacingMedium};

    .newContactDetailsWrapper {
      padding-top: ${variables.spacingMedium};

      ${respondTo.desktop`
        padding: 0;
      `};
    }

    ${respondTo.desktop`
      display: flex;
      flex-direction: row;

      p,
      .formRowWrapper {
        width: 85%;
      }
    `};
  }

  .dateField {
    flex-direction: row !important;
  }

  .formAddress {
    width: 100%;
      padding-top ${variables.spacingSmall};

      ${respondTo.desktop`
        width: 50%;
      `};
    }
  }

  .formRowWrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: ${variables.spacingMedium};

    &.withCheckbox {
      margin-top: -${variables.spacingSmall}
    }

    &.withInfo {
      width: 100%;
      justify-content: space-between;
      flex-direction: column;

      ${respondTo.desktop`
        flex-direction: row;
      `};

      .infoPart {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 48%;
        `};
      }

      .fieldWrapper {
        ${respondTo.desktop`
          width: 46%;
        `};
      }
    }

    &.withMpan {
      width: 100%;
      flex-direction: column;

      ${respondTo.desktop`
        flex-direction: row;
      `};

      .mpanList {
        overflow-y: auto;
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 35%;
        `};
      }

      .mpanInfo {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 48%;
        `};
      }
    }

    &.withContactDetails {
      width: 100%;
      flex-direction: column;

      ${respondTo.desktop`
        flex-direction: row;
      `};

      .contactInfo {
        width: 100%;
        text-align: center;
        padding-bottom: ${variables.spacingSmall};;

        ${respondTo.desktop`
          width: 35%;
          text-align: left;
          padding-bottom: 0;
        `};
      }

      .contactInput {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 20%;
        `};
      }

      .submitEmail {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 70%;
        `};
      }

      .submitBtn {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktopXl`
          width: 30%;
        `};
      }
    }

    &:last-child {
      margin: 0;
    }

    // ${respondTo.desktop`
    //   width: 46%;
    // `};
  }

  .siteTitle {
    font-size: ${variables.fontSizeBase};
    color: ${({ theme }) => theme.text.secondary};
    min-height: 3em;
    display: flex;
    align-items: flex-end;
    margin-bottom: ${variables.spacingSmall};
  }

  .numberBadge {
    font-size: ${variables.fontSizeLarge};
  }

  .commentBox {
    font-weight: normal;
  }
`;

export const SitesWrapper = styled(BlockWrapper)`
  th {
    color: ${({ theme }) => theme.primary.bg};
  }
`;

export const SiteContactDetailsWrapper = styled(BlockWrapper)`
  background-color: transparent;
  box-shadow: none;
  border-bottom: 1px dashed black;
  border-radius: 0px;

  th {
    color: ${({ theme }) => theme.primary.bg};
  }

  .form-element {
    padding: 0.85em 0.9735em;
  }

  .dateField {
    flex-direction: row !important;
    margin-left: 1.5rem !important;
    margin-right: 1.5rem !important;

    ${respondTo.desktop`
      margin-left: 3rem !important;
      margin-right: 3rem !important;
      margin-bottom: 0
    `};
  }

  .reference-box-input {
    height: 50px;
    padding-top: 10px;
    font-weight: normal;
  }
`;

export const FinalReadWrapper = styled(BlockWrapper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ReviewInfoRow = styled.div`
  border-bottom: 1px solid ${colors.darkGrey};
  margin-bottom: ${variables.spacingMedium};

  &:last-child {
    border: none;
    margin: 0;
  }
`;

export const MeterUpgradeWrapper = styled.div`
  .selectedAccountDisplay {
    padding: 4px 40px !important;
    border: 1px solid #bbbbbb;
    border-radius: 16px;
    min-height: 32px !important;
    color: ${colors.oxfordBlue};
    white-space: nowrap;
    width: 200px;
    background-color: ${colors.lightGrey};
    font-size: 16px;
    margin: 2px;
    text-align: center;
    opacity: 0.5;
  }

  .requiredFieldText {
    padding-top: 1rem;

    ${mixins.respondTo.desktopXl`
      padding-top: 0;
    `};
  }

  .navigationBar {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
    padding-left: 1.5rem !important;

    ${mixins.respondTo.tablet`
      padding-bottom: 0 !important;
      padding-left: 0 !important;
    `};
  }

  .pageDescription {
    padding-left: ${variables.spacingSmall};
    ${mixins.respondTo.desktop`
      padding-left: ${variables.spacingMedium};
    `};
  }

  .formRowWrapper {
    display: flex;
    flex-direction: column;

    &.withInfo {
      width: 100%;
      justify-content: space-between;
      flex-direction: column;

      ${respondTo.desktop`
        flex-direction: row;
      `};

      .infoPart {
        width: 100%;
        padding-top ${variables.spacingSmall};

        ${respondTo.desktop`
          width: 48%;
        `};
      }

      .fieldWrapper {
        ${respondTo.desktop`
          width: 46%;
        `};
      }
    }
  }
`;

export const MeterUpgradeChooseSiteWrapper = styled.div`
  .nextButton {
    display: flex;
    width: 95%;
    justify-content: end;

    ${mixins.respondTo.tablet`
      width: 75%;
    `};
  }

  .pageText {
    width: 95%;

    ${mixins.respondTo.tablet`
      width: 75%;
    `};
  }
`;
